import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.match.js";
import "core-js/modules/es.string.replace.js";
import { ENV_IOS, ENV_ANDROID } from '../../const';
/**
 * 获取客户端基础信息
 */

export function getNativeInfo() {
  var ua = navigator.userAgent;
  var patt = /bcz_(ma|app|lite)_([a-zA-Z]+)_?(ireading)?\/(\d+)/i;
  var baseGroup = ua.match(patt);
  var isApp = false;
  var env = null;
  var app = null;
  var appVersion = null;
  var device = null;
  var osVersion = null;

  if (baseGroup) {
    isApp = true;
    appVersion = baseGroup[4]; // init `env`

    {
      switch (baseGroup[2]) {
        case 'iphone':
        case 'ipad':
        case 'ios':
          {
            env = ENV_IOS;
            break;
          }

        case 'android':
          {
            env = ENV_ANDROID;
            break;
          }
      }
    } // init `app`

    {
      switch (baseGroup[1]) {
        case 'app':
          {
            app = baseGroup[3] === 'ireading' ? 'ireading' : 'baicizhan';
            break;
          }

        case 'ma':
          {
            app = 'magic';
            break;
          }

        case 'lite':
          {
            app = 'bcz-lite';
            break;
          }
      }
    } // init `osVersion` and `device

    {
      var androidVersionGroup = ua.match(/android_version\/(\d*\.?\d*)/);

      if (androidVersionGroup) {
        osVersion = androidVersionGroup[1];
      } // 和客户端约定，`device_name` 始终作为最后一段，否则不方便做正则判断


      var androidDeviceGroup = ua.match(/device_name\/(.+)$/);

      if (androidDeviceGroup) {
        device = androidDeviceGroup[1];
      }

      var iosGroup = ua.match(/(iPhone|iPad|Macintosh)[^\d]+?(\d+(?:_\d+){0,2})/);

      if (iosGroup) {
        // `14_6` => `14.6`
        osVersion = iosGroup[2].replace(/_/g, '.');
        device = iosGroup[1];
      }
    }
  } else {
    isApp = false;
  }

  return {
    isApp: isApp,
    env: env,
    app: app,
    appVersion: appVersion,
    device: device,
    osVersion: osVersion
  };
}